var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{on:{"click":function($event){return _vm.launchFilePicker()}}},[_vm._t("default")],2),_vm._v(" "),_c('input',{ref:"file",staticStyle:{"display":"none"},attrs:{"type":"file"},on:{"input":function($event){return _vm.onFileChange(
          $event.target.name, $event.target.files)}}})])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5cffcb8c","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/global/miscellaneous/PictureUpload.vue
// module id = null
// module chunks = 